/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsBase {
    type: string;

    protected setDiscriminator(type: string) {
        this.type = type;
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsBase.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsBase>): ServiceAccountNativeDetailsBase {
        let obj = Object.assign(new ServiceAccountNativeDetailsBase(), model);
        ServiceAccountNativeDetailsBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsBase>): ServiceAccountNativeDetailsBase {
        if (!model) return null;
        return ServiceAccountNativeDetailsBase.newInstance(<ServiceAccountNativeDetailsBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsBase) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsBase): boolean {
        switch (obj.type)
        {
            case "ServiceAccountNativeDetailsBaseForAiPlatform":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsBaseForAiPlatform.prototype);
                break;
            case "ServiceAccountNativeDetailsBaseForAws":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsBaseForAws.prototype);
                break;
            case "ServiceAccountNativeDetailsBaseForAzure":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsBaseForAzure.prototype);
                break;
            case "ServiceAccountNativeDetailsBaseForAzureEaMaster":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsBaseForAzureEaMaster.prototype);
                break;
            case "ServiceAccountNativeDetailsBaseForAzureSubscription":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsBaseForAzureSubscription.prototype);
                break;
            case "ServiceAccountNativeDetailsBaseForCloud":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsBaseForCloud.prototype);
                break;
            case "ServiceAccountNativeDetailsBaseForCostCenter":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsBaseForCostCenter.prototype);
                break;
            case "ServiceAccountNativeDetailsBaseForCostCenterCloud":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsBaseForCostCenterCloud.prototype);
                break;
            case "ServiceAccountNativeDetailsBaseForCostCenterDimension":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsBaseForCostCenterDimension.prototype);
                break;
            case "ServiceAccountNativeDetailsBaseForGcp":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsBaseForGcp.prototype);
                break;
            case "ServiceAccountNativeDetailsBaseForIntegratedTool":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsBaseForIntegratedTool.prototype);
                break;
            case "ServiceAccountNativeDetailsBaseForJiraServiceManagement":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsBaseForJiraServiceManagement.prototype);
                break;
            case "ServiceAccountNativeDetailsBaseForKubernetesCluster":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsBaseForKubernetesCluster.prototype);
                break;
            case "ServiceAccountNativeDetailsBaseForKubernetesClusterCloud":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsBaseForKubernetesClusterCloud.prototype);
                break;
            case "ServiceAccountNativeDetailsBaseForKubernetesClusterOthers":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsBaseForKubernetesClusterOthers.prototype);
                break;
            case "ServiceAccountNativeDetailsBaseForResource":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsBaseForResource.prototype);
                break;
            case "ServiceAccountNativeDetailsBaseForSaas":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsBaseForSaas.prototype);
                break;
            case "ServiceAccountNativeDetailsBaseForSaasAiServices":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsBaseForSaasAiServices.prototype);
                break;
            case "ServiceAccountNativeDetailsBaseForSaasDataServices":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsBaseForSaasDataServices.prototype);
                break;
            case "ServiceAccountNativeDetailsBaseForSaasOtherServices":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsBaseForSaasOtherServices.prototype);
                break;
            case "ServiceAccountNativeDetailsBaseForStructure":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsBaseForStructure.prototype);
                break;
            case "ServiceAccountNativeDetailsForAnthropicPlatform":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForAnthropicPlatform.prototype);
                break;
            case "ServiceAccountNativeDetailsForAppDynamics":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForAppDynamics.prototype);
                break;
            case "ServiceAccountNativeDetailsForAppInsights":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForAppInsights.prototype);
                break;
            case "ServiceAccountNativeDetailsForAwsEksCluster":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForAwsEksCluster.prototype);
                break;
            case "ServiceAccountNativeDetailsForAwsManagementAccount":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForAwsManagementAccount.prototype);
                break;
            case "ServiceAccountNativeDetailsForAwsMemberAccount":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForAwsMemberAccount.prototype);
                break;
            case "ServiceAccountNativeDetailsForAwsOrganizationUnit":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForAwsOrganizationUnit.prototype);
                break;
            case "ServiceAccountNativeDetailsForAzureAksCluster":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForAzureAksCluster.prototype);
                break;
            case "ServiceAccountNativeDetailsForAzureCspCustomer":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForAzureCspCustomer.prototype);
                break;
            case "ServiceAccountNativeDetailsForAzureCspMaster":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForAzureCspMaster.prototype);
                break;
            case "ServiceAccountNativeDetailsForAzureCspPartner":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForAzureCspPartner.prototype);
                break;
            case "ServiceAccountNativeDetailsForAzureCspSubscription":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForAzureCspSubscription.prototype);
                break;
            case "ServiceAccountNativeDetailsForAzureDevops":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForAzureDevops.prototype);
                break;
            case "ServiceAccountNativeDetailsForAzureEaAccount":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForAzureEaAccount.prototype);
                break;
            case "ServiceAccountNativeDetailsForAzureEaApiKeyMaster":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForAzureEaApiKeyMaster.prototype);
                break;
            case "ServiceAccountNativeDetailsForAzureEaApplicationMaster":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForAzureEaApplicationMaster.prototype);
                break;
            case "ServiceAccountNativeDetailsForAzureEaDepartment":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForAzureEaDepartment.prototype);
                break;
            case "ServiceAccountNativeDetailsForAzureEaSubscription":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForAzureEaSubscription.prototype);
                break;
            case "ServiceAccountNativeDetailsForAzureMcaBillingAccount":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForAzureMcaBillingAccount.prototype);
                break;
            case "ServiceAccountNativeDetailsForAzureMcaBillingProfile":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForAzureMcaBillingProfile.prototype);
                break;
            case "ServiceAccountNativeDetailsForAzureMcaInvoiceSection":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForAzureMcaInvoiceSection.prototype);
                break;
            case "ServiceAccountNativeDetailsForAzureMcaSubscription":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForAzureMcaSubscription.prototype);
                break;
            case "ServiceAccountNativeDetailsForAzureSecurityGraph":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForAzureSecurityGraph.prototype);
                break;
            case "ServiceAccountNativeDetailsForAzureSentinel":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForAzureSentinel.prototype);
                break;
            case "ServiceAccountNativeDetailsForAzureStack":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForAzureStack.prototype);
                break;
            case "ServiceAccountNativeDetailsForAzureSubscription":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForAzureSubscription.prototype);
                break;
            case "ServiceAccountNativeDetailsForCircleCI":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForCircleCI.prototype);
                break;
            case "ServiceAccountNativeDetailsForCloudstack":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForCloudstack.prototype);
                break;
            case "ServiceAccountNativeDetailsForCorestack":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForCorestack.prototype);
                break;
            case "ServiceAccountNativeDetailsForCostCenterAws":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForCostCenterAws.prototype);
                break;
            case "ServiceAccountNativeDetailsForCostCenterAzure":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForCostCenterAzure.prototype);
                break;
            case "ServiceAccountNativeDetailsForCostCenterDimension":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForCostCenterDimension.prototype);
                break;
            case "ServiceAccountNativeDetailsForCostCenterDimensionGroupingRule":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForCostCenterDimensionGroupingRule.prototype);
                break;
            case "ServiceAccountNativeDetailsForCostCenterGcp":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForCostCenterGcp.prototype);
                break;
            case "ServiceAccountNativeDetailsForCostCenterOci":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForCostCenterOci.prototype);
                break;
            case "ServiceAccountNativeDetailsForCustomSaasTool":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForCustomSaasTool.prototype);
                break;
            case "ServiceAccountNativeDetailsForDataBricks":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForDataBricks.prototype);
                break;
            case "ServiceAccountNativeDetailsForDataDog":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForDataDog.prototype);
                break;
            case "ServiceAccountNativeDetailsForDockerHub":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForDockerHub.prototype);
                break;
            case "ServiceAccountNativeDetailsForDropbox":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForDropbox.prototype);
                break;
            case "ServiceAccountNativeDetailsForDynatrace":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForDynatrace.prototype);
                break;
            case "ServiceAccountNativeDetailsForElastic":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForElastic.prototype);
                break;
            case "ServiceAccountNativeDetailsForElasticSearch":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForElasticSearch.prototype);
                break;
            case "ServiceAccountNativeDetailsForFreshservice":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForFreshservice.prototype);
                break;
            case "ServiceAccountNativeDetailsForGcpBillingAccount":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForGcpBillingAccount.prototype);
                break;
            case "ServiceAccountNativeDetailsForGcpBillingSubAccount":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForGcpBillingSubAccount.prototype);
                break;
            case "ServiceAccountNativeDetailsForGcpFolder":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForGcpFolder.prototype);
                break;
            case "ServiceAccountNativeDetailsForGcpGkeCluster":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForGcpGkeCluster.prototype);
                break;
            case "ServiceAccountNativeDetailsForGcpOrganization":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForGcpOrganization.prototype);
                break;
            case "ServiceAccountNativeDetailsForGcpParentBillingAccount":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForGcpParentBillingAccount.prototype);
                break;
            case "ServiceAccountNativeDetailsForGcpProject":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForGcpProject.prototype);
                break;
            case "ServiceAccountNativeDetailsForGithubBase":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForGithubBase.prototype);
                break;
            case "ServiceAccountNativeDetailsForGithubEnterprise":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForGithubEnterprise.prototype);
                break;
            case "ServiceAccountNativeDetailsForGithubOrganization":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForGithubOrganization.prototype);
                break;
            case "ServiceAccountNativeDetailsForGrafana":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForGrafana.prototype);
                break;
            case "ServiceAccountNativeDetailsForIbmTencent":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForIbmTencent.prototype);
                break;
            case "ServiceAccountNativeDetailsForJenkins":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForJenkins.prototype);
                break;
            case "ServiceAccountNativeDetailsForJiraDataCenter":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForJiraDataCenter.prototype);
                break;
            case "ServiceAccountNativeDetailsForJiraServiceDesk":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForJiraServiceDesk.prototype);
                break;
            case "ServiceAccountNativeDetailsForJiraServiceManagementParent":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForJiraServiceManagementParent.prototype);
                break;
            case "ServiceAccountNativeDetailsForJiraServiceManagementProject":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForJiraServiceManagementProject.prototype);
                break;
            case "ServiceAccountNativeDetailsForLogstash":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForLogstash.prototype);
                break;
            case "ServiceAccountNativeDetailsForMicrosoftTeams":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForMicrosoftTeams.prototype);
                break;
            case "ServiceAccountNativeDetailsForMsVmm":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForMsVmm.prototype);
                break;
            case "ServiceAccountNativeDetailsForNagios":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForNagios.prototype);
                break;
            case "ServiceAccountNativeDetailsForNewrelic":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForNewrelic.prototype);
                break;
            case "ServiceAccountNativeDetailsForOciOkeCluster":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForOciOkeCluster.prototype);
                break;
            case "ServiceAccountNativeDetailsForOciTenancy":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForOciTenancy.prototype);
                break;
            case "ServiceAccountNativeDetailsForOkta":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForOkta.prototype);
                break;
            case "ServiceAccountNativeDetailsForOpenAI":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForOpenAI.prototype);
                break;
            case "ServiceAccountNativeDetailsForOpenstack":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForOpenstack.prototype);
                break;
            case "ServiceAccountNativeDetailsForPrivateCloud":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForPrivateCloud.prototype);
                break;
            case "ServiceAccountNativeDetailsForPrometheus":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForPrometheus.prototype);
                break;
            case "ServiceAccountNativeDetailsForQualys":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForQualys.prototype);
                break;
            case "ServiceAccountNativeDetailsForRackspace":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForRackspace.prototype);
                break;
            case "ServiceAccountNativeDetailsForRedhatSatellite":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForRedhatSatellite.prototype);
                break;
            case "ServiceAccountNativeDetailsForSaasMicrosoftTeams":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForSaasMicrosoftTeams.prototype);
                break;
            case "ServiceAccountNativeDetailsForSaasNewRelic":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForSaasNewRelic.prototype);
                break;
            case "ServiceAccountNativeDetailsForSalesForceSalesCloud":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForSalesForceSalesCloud.prototype);
                break;
            case "ServiceAccountNativeDetailsForSelfManagedCluster":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForSelfManagedCluster.prototype);
                break;
            case "ServiceAccountNativeDetailsForServiceNow":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForServiceNow.prototype);
                break;
            case "ServiceAccountNativeDetailsForSnowflake":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForSnowflake.prototype);
                break;
            case "ServiceAccountNativeDetailsForSplunk":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForSplunk.prototype);
                break;
            case "ServiceAccountNativeDetailsForTclItsm":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForTclItsm.prototype);
                break;
            case "ServiceAccountNativeDetailsForTenableNessus":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForTenableNessus.prototype);
                break;
            case "ServiceAccountNativeDetailsForVcenter":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForVcenter.prototype);
                break;
            case "ServiceAccountNativeDetailsForVmware":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForVmware.prototype);
                break;
            case "ServiceAccountNativeDetailsForVmwareVcdMaster":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForVmwareVcdMaster.prototype);
                break;
            case "ServiceAccountNativeDetailsForVmwareVcdOrganization":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForVmwareVcdOrganization.prototype);
                break;
            case "ServiceAccountNativeDetailsForVmwareVcdOrganizationVdc":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForVmwareVcdOrganizationVdc.prototype);
                break;
            case "ServiceAccountNativeDetailsForZabbix":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForZabbix.prototype);
                break;
            case "ServiceAccountNativeDetailsForZohoServiceDesk":
                Object.setPrototypeOf(obj, models.ServiceAccountNativeDetailsForZohoServiceDesk.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof ServiceAccountNativeDetailsBase)[] {
        return [
            models.ServiceAccountNativeDetailsBaseForAiPlatform,
            models.ServiceAccountNativeDetailsBaseForAws,
            models.ServiceAccountNativeDetailsBaseForAzure,
            models.ServiceAccountNativeDetailsBaseForAzureEaMaster,
            models.ServiceAccountNativeDetailsBaseForAzureSubscription,
            models.ServiceAccountNativeDetailsBaseForCloud,
            models.ServiceAccountNativeDetailsBaseForCostCenter,
            models.ServiceAccountNativeDetailsBaseForCostCenterCloud,
            models.ServiceAccountNativeDetailsBaseForCostCenterDimension,
            models.ServiceAccountNativeDetailsBaseForGcp,
            models.ServiceAccountNativeDetailsBaseForIntegratedTool,
            models.ServiceAccountNativeDetailsBaseForJiraServiceManagement,
            models.ServiceAccountNativeDetailsBaseForKubernetesCluster,
            models.ServiceAccountNativeDetailsBaseForKubernetesClusterCloud,
            models.ServiceAccountNativeDetailsBaseForKubernetesClusterOthers,
            models.ServiceAccountNativeDetailsBaseForResource,
            models.ServiceAccountNativeDetailsBaseForSaas,
            models.ServiceAccountNativeDetailsBaseForSaasAiServices,
            models.ServiceAccountNativeDetailsBaseForSaasDataServices,
            models.ServiceAccountNativeDetailsBaseForSaasOtherServices,
            models.ServiceAccountNativeDetailsBaseForStructure,
            models.ServiceAccountNativeDetailsForAnthropicPlatform,
            models.ServiceAccountNativeDetailsForAppDynamics,
            models.ServiceAccountNativeDetailsForAppInsights,
            models.ServiceAccountNativeDetailsForAwsEksCluster,
            models.ServiceAccountNativeDetailsForAwsManagementAccount,
            models.ServiceAccountNativeDetailsForAwsMemberAccount,
            models.ServiceAccountNativeDetailsForAwsOrganizationUnit,
            models.ServiceAccountNativeDetailsForAzureAksCluster,
            models.ServiceAccountNativeDetailsForAzureCspCustomer,
            models.ServiceAccountNativeDetailsForAzureCspMaster,
            models.ServiceAccountNativeDetailsForAzureCspPartner,
            models.ServiceAccountNativeDetailsForAzureCspSubscription,
            models.ServiceAccountNativeDetailsForAzureDevops,
            models.ServiceAccountNativeDetailsForAzureEaAccount,
            models.ServiceAccountNativeDetailsForAzureEaApiKeyMaster,
            models.ServiceAccountNativeDetailsForAzureEaApplicationMaster,
            models.ServiceAccountNativeDetailsForAzureEaDepartment,
            models.ServiceAccountNativeDetailsForAzureEaSubscription,
            models.ServiceAccountNativeDetailsForAzureMcaBillingAccount,
            models.ServiceAccountNativeDetailsForAzureMcaBillingProfile,
            models.ServiceAccountNativeDetailsForAzureMcaInvoiceSection,
            models.ServiceAccountNativeDetailsForAzureMcaSubscription,
            models.ServiceAccountNativeDetailsForAzureSecurityGraph,
            models.ServiceAccountNativeDetailsForAzureSentinel,
            models.ServiceAccountNativeDetailsForAzureStack,
            models.ServiceAccountNativeDetailsForAzureSubscription,
            models.ServiceAccountNativeDetailsForCircleCI,
            models.ServiceAccountNativeDetailsForCloudstack,
            models.ServiceAccountNativeDetailsForCorestack,
            models.ServiceAccountNativeDetailsForCostCenterAws,
            models.ServiceAccountNativeDetailsForCostCenterAzure,
            models.ServiceAccountNativeDetailsForCostCenterDimension,
            models.ServiceAccountNativeDetailsForCostCenterDimensionGroupingRule,
            models.ServiceAccountNativeDetailsForCostCenterGcp,
            models.ServiceAccountNativeDetailsForCostCenterOci,
            models.ServiceAccountNativeDetailsForCustomSaasTool,
            models.ServiceAccountNativeDetailsForDataBricks,
            models.ServiceAccountNativeDetailsForDataDog,
            models.ServiceAccountNativeDetailsForDockerHub,
            models.ServiceAccountNativeDetailsForDropbox,
            models.ServiceAccountNativeDetailsForDynatrace,
            models.ServiceAccountNativeDetailsForElastic,
            models.ServiceAccountNativeDetailsForElasticSearch,
            models.ServiceAccountNativeDetailsForFreshservice,
            models.ServiceAccountNativeDetailsForGcpBillingAccount,
            models.ServiceAccountNativeDetailsForGcpBillingSubAccount,
            models.ServiceAccountNativeDetailsForGcpFolder,
            models.ServiceAccountNativeDetailsForGcpGkeCluster,
            models.ServiceAccountNativeDetailsForGcpOrganization,
            models.ServiceAccountNativeDetailsForGcpParentBillingAccount,
            models.ServiceAccountNativeDetailsForGcpProject,
            models.ServiceAccountNativeDetailsForGithubBase,
            models.ServiceAccountNativeDetailsForGithubEnterprise,
            models.ServiceAccountNativeDetailsForGithubOrganization,
            models.ServiceAccountNativeDetailsForGrafana,
            models.ServiceAccountNativeDetailsForIbmTencent,
            models.ServiceAccountNativeDetailsForJenkins,
            models.ServiceAccountNativeDetailsForJiraDataCenter,
            models.ServiceAccountNativeDetailsForJiraServiceDesk,
            models.ServiceAccountNativeDetailsForJiraServiceManagementParent,
            models.ServiceAccountNativeDetailsForJiraServiceManagementProject,
            models.ServiceAccountNativeDetailsForLogstash,
            models.ServiceAccountNativeDetailsForMicrosoftTeams,
            models.ServiceAccountNativeDetailsForMsVmm,
            models.ServiceAccountNativeDetailsForNagios,
            models.ServiceAccountNativeDetailsForNewrelic,
            models.ServiceAccountNativeDetailsForOciOkeCluster,
            models.ServiceAccountNativeDetailsForOciTenancy,
            models.ServiceAccountNativeDetailsForOkta,
            models.ServiceAccountNativeDetailsForOpenAI,
            models.ServiceAccountNativeDetailsForOpenstack,
            models.ServiceAccountNativeDetailsForPrivateCloud,
            models.ServiceAccountNativeDetailsForPrometheus,
            models.ServiceAccountNativeDetailsForQualys,
            models.ServiceAccountNativeDetailsForRackspace,
            models.ServiceAccountNativeDetailsForRedhatSatellite,
            models.ServiceAccountNativeDetailsForSaasMicrosoftTeams,
            models.ServiceAccountNativeDetailsForSaasNewRelic,
            models.ServiceAccountNativeDetailsForSalesForceSalesCloud,
            models.ServiceAccountNativeDetailsForSelfManagedCluster,
            models.ServiceAccountNativeDetailsForServiceNow,
            models.ServiceAccountNativeDetailsForSnowflake,
            models.ServiceAccountNativeDetailsForSplunk,
            models.ServiceAccountNativeDetailsForTclItsm,
            models.ServiceAccountNativeDetailsForTenableNessus,
            models.ServiceAccountNativeDetailsForVcenter,
            models.ServiceAccountNativeDetailsForVmware,
            models.ServiceAccountNativeDetailsForVmwareVcdMaster,
            models.ServiceAccountNativeDetailsForVmwareVcdOrganization,
            models.ServiceAccountNativeDetailsForVmwareVcdOrganizationVdc,
            models.ServiceAccountNativeDetailsForZabbix,
            models.ServiceAccountNativeDetailsForZohoServiceDesk,
        ];
    }

    fixupFields() {
    }

}
